import { render } from "./Home.vue?vue&type=template&id=17c241d0&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=17c241d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c241d0"]])

export default __exports__